import React from 'react';
import { Navigate } from 'react-router-dom';

const AdminLogin = () => <Navigate to="/login?mode=admin" replace />;

export default AdminLogin;
